import apiService from './apiService';

const paymentService = {
  getPaymentStatus: async (paymentId) => {
    try {
      const response = await apiService.get(`/payments/status/${paymentId}`);
      return response;
    } catch (error) {
      console.error(`Error fetching payment status for ID ${paymentId}:`, error);
      throw error;
    }
  },

  // Publikus fizetési beállítások (pl. elérhető-e a Barion ezen a környezeten)
  getConfig: async () => apiService.get('/payments/config'),

  // Barionos foglalás-fizetés indítása — a válasz redirectUrl-jére kell irányítani
  initiateBarionPayment: async (bookingIds, paymentStep, checkoutDetails) =>
    apiService.post('/payments/initiate', { bookingIds, paymentStep, checkoutDetails }),
};

export default paymentService;